/**
 * Map intake.spamSource to a Triage badge (AI / MTA / routine / unknown).
 */

export type SpamSourceKind = 'ai' | 'mta' | 'routine' | 'allowlist' | 'unknown';

export type SpamSourceBadge = {
    kind: SpamSourceKind;
    /** i18n key under priorities.spam_source.* */
    labelKey: string;
    /** flowbite Badge color */
    color: 'purple' | 'warning' | 'info' | 'success' | 'gray';
};

/**
 * Classify a stored spamSource string (or missing value on a spam_suspect card).
 */
export const classifySpamSource = (spamSource?: string | null): SpamSourceBadge => {
    const raw = String(spamSource || '').trim().toLowerCase();
    if (!raw)
        return { kind: 'routine', labelKey: 'priorities.spam_source.routine', color: 'info' };
    if (raw === 'ai')
        return { kind: 'ai', labelKey: 'priorities.spam_source.ai', color: 'purple' };
    if (raw === 'allowlist')
        return { kind: 'allowlist', labelKey: 'priorities.spam_source.allowlist', color: 'success' };
    if (raw === 'routine' || raw.startsWith('routine'))
        return { kind: 'routine', labelKey: 'priorities.spam_source.routine', color: 'info' };
    if (raw.startsWith('mta_') || raw === 'mta')
        return { kind: 'mta', labelKey: 'priorities.spam_source.mta', color: 'warning' };
    return { kind: 'unknown', labelKey: 'priorities.spam_source.unknown', color: 'gray' };
};
